import { FeatureFlag } from '@sparelabs/feature-flags'
import { useFormContext } from '../pages/Form/FormContext'

export interface IFeatureFlagResult {
  isEnabled: boolean
  isLoading: boolean
}

/**
 * Hook to check public feature flags from the organization data.
 * This works for public forms and uses the enabledPublicFeatureFlags from the organization response.
 */
export const useFeatureFlag = (featureFlag: FeatureFlag): IFeatureFlagResult => {
  const { organization } = useFormContext()

  return {
    isEnabled: organization?.enabledPublicFeatureFlags?.includes(featureFlag) ?? false,
    isLoading: false, // No loading since we already have the organization data from context
  }
}
